import { render, staticRenderFns } from "./SendMailSMSConfirmation.vue?vue&type=template&id=339cc922&"
import script from "./SendMailSMSConfirmation.vue?vue&type=script&lang=js&"
export * from "./SendMailSMSConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports